'use strict';

define('AppRootFac',['lodash'],
    function (_) {

        AppRootFac.$inject = [
            '$rootScope',
            '$uibModal',
            'ConfigurationFac',
            'ContentFac',
            'FeaturesHandlerSvc',
            '$uibModalStack',
            '$location',
            '$window',
            'CMSCONTENT',
            'CookieFac',
            'UserSessionSvc',
            'GTMFac',
            'NewWindowGridFac',
            '$document',
            '$timeout',
            'SecuritySvc',
            'FavoriteTracksFac'
        ];

        function AppRootFac($rootScope,
                            $uibModal,
                            ConfigurationFac,
                            ContentFac,
                            FeaturesHandlerSvc,
                            $uibModalStack,
                            $location,
                            $window,
                            CMSCONTENT,
                            CookieFac,
                            UserSessionSvc,
                            GTMFac,
                            NewWindowGridFac,
                            $document,
                            $timeout,
                            SecuritySvc,
                            FavoriteTracksFac) {
            var doneUserGTM = false;
            var userSessionUnwatch;
            var GTMUserLoggedOutUnwatch;

            // Configuration needs to be set again when angular app boots
            ConfigurationFac.setApplicationContextItem('product', productContext);
            ConfigurationFac.setApplicationContextItem('application', applicationContext);
            ConfigurationFac.setApplicationContextItem('location', locationContext);

            //rootScope config variables
            $rootScope.isIE = document.documentMode !== undefined;//Check if the current browser is the IE.
            $rootScope.activeFeatures = {};
            $rootScope.enableGTM = true;
            $rootScope.appName = 'TVG';
            $rootScope.allowedRaces = [];
            $rootScope.uniqueVideoId = 0;
            $rootScope.withdrawData = {
                haveRequestedInfo: false,
                pendingListWithdraw: []
            };
            $rootScope.firstLoad = true;
            $rootScope.locationContext = locationContext;
            $rootScope.productContext = 'tvg4';

            // Location overrides
            if (locationContext == 'nj') {
                $rootScope.appName = '4NJBets';
                $rootScope.product = $rootScope.product + locationContext;
            }

            if ($location.path() === "/deposit") {
                $rootScope.showAccountPanel = true;
            }

            ContentFac.setCMSContent(CMSCONTENT);
            ContentFac.restoreCache(cmsCache);

            $rootScope.appReadyFired = false;
            $rootScope.sessionRequested = false;
            $rootScope.appReady = {};

            function _initBetSlip() {
                FeaturesHandlerSvc.init();

                if ($rootScope.activeFeatures.openBetWindowsInGrid) {
                    NewWindowGridFac.windowFunctions($window);
                }



                $rootScope.productContext = 'tvg4';
                applicationContext = 'desktop';
                ConfigurationFac.setApplicationContextItem('application', applicationContext);
                ConfigurationFac.setApplicationContextItem('device', 'desktop');
                $rootScope.cssFile = $rootScope.productContext;
                $rootScope.isBetslipApp = true;

                _gtmSessionWatchers();
            }

            function _redirectFromPaymentMethod(path) {
                if (_.includes(path, 'activeTab=sightline')) {
                    return {
                        tla: 'SLN',
                        menutab: getActiveMenuTab(path),
                        fullname: 'Sightline'
                    };
                }

                if (_.includes(path, 'activeTab=paypal')) {
                    return {
                        tla: 'PAY',
                        menutab: getActiveMenuTab(path),
                        fullname: 'Paypal'
                    };
                }

                return {};
            }

            /* ----- RootScope Functions ----- */

            function _fnGo() {
                $rootScope.go = function (path, param) {
                    param = typeof param !== 'undefined' ? param : false;

                    $timeout(function () {
                        if (param) {
                            $location.path(path).search(param);
                        }
                        else {
                            $location.path(path);
                        }
                    });


                    if (path === 'joinnow') {
                        $rootScope.firstTimeJoinNow = true;
                    }
                };
            }

            function _fnGetLocationPath() {
                $rootScope.getLocationPath = function () {
                    return $location.path();
                };
            }

            /* ----- RootScope Listeneners ----- */

            function _onUser() {
                var locationOnuser = $rootScope.$on('user', function () {
                    $rootScope.hasNeverLogin = !CookieFac.getCookie("hasLoginOnce");
                    _launchGTMEvent();
                    locationOnuser();
                });
            }

            function _onLocationChangeStart() {
                var redirectFromPaymentObj;

                $rootScope.$on('$locationChangeStart', function () {
                    var url = $location.url();
                    redirectFromPaymentObj = _redirectFromPaymentMethod(url);
                    // Scroll to top
                    _scrollToTop();

                    // On mobile videos need to be stopped to not crash application
                    if (applicationContext === 'mobile') {
                        _stopVideos();
                    }

                    if ($rootScope.userSession !== undefined || doneUserGTM) {
                        _launchGTMEvent();
                    }

                    // this prevents the session expired popup alert not to be dismissed when
                    // the session expires and we redirect the user to the home route
                    if ($location.hash() !== 'sessionExpired') {
                        // other than that, always dismiss all modals when changing routes
                        $uibModalStack.dismissAll();
                    }

                    var route = $location.path().split("/")[1];

                    $rootScope.hasNeverLogin = !CookieFac.getCookie("hasLoginOnce");
                    $rootScope.logoutOk = true;
                    $rootScope.loginOk = true;
                    $rootScope.isLandingPageLocation = !!(route == "joinnow" || route == "landingpage");

                    $rootScope.pageTitle = "";
                    $rootScope.pageTitleRaceMobile = "";
                    $rootScope.pageTitleTrackNameMobile = "";
                    $rootScope.pageSubTitle = "";
                    $rootScope.moreDetails = "";

                    if ($location.path() === "/registration") {
                        RegistrationPageGTMFac.register();
                        $rootScope.pageTitle = $rootScope.appName;
                        $rootScope.pageTitleRaceMobile = $rootScope.appName;
                        $rootScope.pageTitleTrackNameMobile = "";
                        $rootScope.pageSubTitle = "Member Registration";
                        $rootScope.moreDetails = "";
                        $rootScope.showNewRegistration = !!$location.search().redirected;
                    }

                    if (!_.isEmpty(redirectFromPaymentObj)) {
                        $rootScope.activeOption = {
                            tla: redirectFromPaymentObj.tla,
                            isPaymentConfirmation: _isPaymentConfirmation(url),
                            userCancelled: _userCancelled(url)
                        };
                        $rootScope.$emit(
                            'redirectFrom'.concat(redirectFromPaymentObj.fullname),
                            redirectFromPaymentObj.menutab,
                            $rootScope.activeOption.isPaymentConfirmation,
                            $rootScope.activeOption.userCancelled
                        );
                    } else {
                        $rootScope.activeOption = undefined;
                    }
                });
            }

            function _isPaymentConfirmation(url) {
                return _.includes(url, '&isPaymentConfirmation=true');
            }

            function _userCancelled(url) {
                return url.indexOf('&userCancelled=true') > -1;
            }

            function _onLocationChangeSuccess() {
                $rootScope.$on('$locationChangeSuccess', function () {
                    // Scroll to top
                    _scrollToTop();
                });
            }

            function _onRouteChangeStart() {
                $rootScope.$on("$routeChangeStart", function (event, next, current) {
                    $rootScope.pageLoadedFired = false;

                    // Scroll to top
                    _scrollToTop();

                    if ((!$rootScope.hasOwnProperty('userSession') || !$rootScope.userSession) && $rootScope.firstLoad === true) {
                        $rootScope.logoutOk = false;
                        $rootScope.firstLoad = false;
                    }

                    if (angular.isString(next.toggleKey)) {
                        var isToggleOff = $rootScope.activeFeatures[next.toggleKey] === false;
                        if (isToggleOff) {
                            $timeout(function () {
                                $location.path("/");
                            });
                        }
                    }

                    if(!$rootScope.sessionRequested) {
                        UserSessionSvc.validate().then(function () {
                            ConfigurationFac.setApplicationContextItem('user_status', 'logged_in');

                            if ($rootScope.userSession && next.originalPath === '/registration') {
                                $timeout(function () {
                                    $location.path('/');
                                });
                            }

                        }, function (response) {
                            //invalidate session only when we get a response with an ErrorCode or if user data doesn't exist
                            if(response.hasOwnProperty('messageKey') && response.messageKey == 'Not Authenticated' || !$rootScope.user) {

                                ConfigurationFac.setApplicationContextItem('user_status', 'logged_out');

                                $rootScope.user = null;
                                $rootScope.userSession = false;
                                FavoriteTracksFac.clearFavoriteList();

                                $rootScope.$broadcast('sessionInvalid');
                            }
                        }).finally(function () {
                            $rootScope.logoutOk = true;
                            $rootScope.sessionRequested = true;
                            $rootScope.appReady.session = true;
                            $rootScope.$broadcast('session');
                        });
                    }

                    if (current && next && next.originalPath !== current.originalPath && next.originalPath !== current.redirectTo && next.title !== 'Races' && next.title !== 'Results') {
                        $rootScope.appTitle = next.title;

                    } else {
                        $rootScope.appTitle = next.title || 'Home Screen';
                        $rootScope.pageReload = current ? true : false;
                        if (next.title === 'Races' && $rootScope.layout !== 'desktop') {
                            if (next.pathParams.raceNumber) {
                                $rootScope.appTitle = 'Races | Free Handicapping';
                            } else {
                                $rootScope.appTitle = 'Races | By Time';
                            }
                        }
                        if (next.title === 'Results') {
                            $rootScope.appTitle = 'Results | By Time';
                        }
                    }

                    if ($location.path() === "/registration" && angular.element(document.querySelector('#smartbanner')).length) {
                        angular.element(document.querySelector('#smartbanner')).hide();
                    } else if (angular.element(document.querySelector('#smartbanner')).length) {
                        angular.element(document.querySelector('#smartbanner')).show();
                    }

                    var route = $location.path().split("/")[1];
                    if (route == "bets" && productContext == "touch2") {
                        if ($rootScope.user) {
                            $uibModal.open({
                                backdropClass: 'tvgmodal-backdrop',
                                windowTemplateUrl: 'js/modules/Utilities/templates/modal-window.html',
                                windowClass: 'account',
                                template: '<stack-view data-root-url="js/mobile/modules/Account/templates/my-bets.html" data-root-title="My Bets"></stack-view>'
                            });
                        } else {
                            $uibModal.open({
                                backdropClass: 'tvgmodal-backdrop',
                                windowTemplateUrl: 'js/modules/Utilities/templates/modal-window.html',
                                windowClass: 'login',
                                template: '<login name="loginModal"></login>'
                            });
                        }
                        event.preventDefault();
                    } else if ((route === 'login' || route === 'dev-login') && productContext === 'tvg4') {
                        $rootScope.$broadcast("callLoginRequiredModal");

                        var gtmEvent = {
                            screenName: 'Login Page **',
                            sectionName: 'Login | Login Page'
                        };

                        GTMFac.GTMEvent().send($rootScope, '', gtmEvent);
                    }
                });
            }

            function _onScrollToTop() {
                $rootScope.$on('scrollToTop', function () {
                    _scrollToTop();
                });
            }

            function _onLogin() {
                $rootScope.$on('login', function () {
                    ConfigurationFac.setApplicationContextItem('user_status', 'logged_in');

                    var cmsCache = ContentFac.retrieveCache();
                    if (cmsCache.hasOwnProperty('landingpages')) {
                        delete cmsCache.landingpages;
                    }
                    ContentFac.restoreCache(cmsCache);

                    $rootScope.$broadcast('afterLogin', true);

                    $rootScope.hasNeverLogin = !CookieFac.getCookie("hasLoginOnce");
                });
            }

            function _onLogout() {
                $rootScope.$on("logout", function () {

                    var cmsCache = ContentFac.retrieveCache();

                    if (cmsCache.hasOwnProperty('landingpages')) {
                        delete cmsCache.landingpages;
                    }

                    ContentFac.restoreCache(cmsCache);

                    if (applicationContext === 'mobile') {
                        _stopVideos();
                    }

                    $rootScope.withdrawData = {
                        haveRequestedInfo: false,
                        pendingListWithdraw: []
                    };
                });
            }

            function _onSessionExpired() {
                $rootScope.$on('sessionExpired', function () {
                    SecuritySvc.logout().then(function () {
                        $timeout(function () {
                            $location.path('/').hash('sessionExpired');
                        });
                    });
                });
            }

            function _onAppReady() {
                $rootScope.$on("appReady", function (event, component) {
                    if ($location.path() === "/") {
                        var appReady = true;

                        if ($rootScope.appReady.hasOwnProperty(component)) {
                            $rootScope.appReady[component] = true;
                        }

                        for (var prop in $rootScope.appReady) {
                            if (!$rootScope.appReady[prop]) appReady = false;
                        }

                        if (appReady) {
                            if (!$rootScope.appReadyFired) {
                                $rootScope.appReadyFired = true;

                                for (var prop in $rootScope.appReady) {
                                    $rootScope.appReady[prop] = false;
                                }
                            }
                            else {
                                for (var prop in $rootScope.appReady) {
                                    $rootScope.appReady[prop] = false;
                                }
                            }
                        }
                    }
                });
            }

            function _onPageLoaded() {
                $rootScope.$on("pageLoaded", function (event, page) {
                    if (!$rootScope.pageLoadedFired) {
                        $rootScope.pageLoadedFired = true;
                    }
                });
            }

            /* ----- GTM Event Listeners ----- */

            function _gtmUserSession() {
                return $rootScope.$watch("userSession", function (currentValue, prevValue) {
                    var isDirectUrlRegistration = (typeof (prevValue) === "undefined" && $location.path().indexOf('registration') === 1);
                    if ((typeof (prevValue) === "undefined" && typeof (currentValue) !== "undefined")
                        || isDirectUrlRegistration) {
                        _launchGTMEvent();
                        //to remove watch
                        if (!isDirectUrlRegistration) {
                            doneUserGTM = true;
                        }
                        _launchGTMAndGAAndUnwatch();
                    }
                });
            }

            function _gtmSessionWatchers() {
                if ($rootScope.enableGTM) {
                    if ($rootScope.isBetslipApp) {
                        // just launch GTM and GA
                        _createGTMandGA();
                        return;
                    }
                    // GTM login and logout watchers
                    userSessionUnwatch = _gtmUserSession();
                    GTMUserLoggedOutUnwatch = _gtmUserLoggedOut();
                }
            }

            function _gtmUserLoggedOut() {
                return $rootScope.$on('GTMUserLoggedOut', function () {
                    doneUserGTM = true;
                    _launchGTMEvent();
                    _launchGTMAndGAAndUnwatch();
                });
            }

            function _launchGTMAndGAAndUnwatch() {
                // launch GTM and GA
                _createGTMandGA();
                GTMUserLoggedOutUnwatch();
                userSessionUnwatch();
            }

            /* ----- GTM Functions ----- */

            function _launchGTMEvent() {
                if (_shouldLaunchPageViewEvent()) {
                    var eventParams = {
                        event: 'ga_pageload',
                        graphVersion: $rootScope.activeFeatures.useJavaGraph ? 'v2' : 'v1'
                    };

                    GTMFac.GTMEvent().send($rootScope, '', eventParams);
                }
            }

            function _shouldLaunchPageViewEvent() {
                return _isPathValid() && _hasSectionName();
            }

            function _isPathValid() {
                return $location.path().split('/').length > 1;
            }

            function _hasSectionName() {
                return GTMFac.Tvg4SectionName() !== "";
            }

            function _createGTMandGA() {
                var noScript = document.createElement("noscript");
                noScript.text =
                    '<iframe src="//www.googletagmanager.com/ns.html?id=GTM-' +
                    ConfigurationFac.getGTMContainerId() +
                    '" height="0" width="0" style="display:none;visibility:hidden"></iframe>';
                document
                    .getElementsByTagName("body")
                    .item(0)
                    .appendChild(noScript);

                /**
                 * Google tag manager injection
                 */
                (function(w, d, s, l, i, e, a) {
                    w[l] = w[l] || [];
                    w[l].push({
                        "gtm.start": new Date().getTime(),
                        event: "gtm.js"
                    });
                    var f = d.getElementsByTagName(s)[0],
                        j = d.createElement(s),
                        dl = l != "dataLayer" ? "&l=" + l : "";
                    j.async = true;
                    j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
                    if (e && a) {
                        j.src =
                            "https://www.googletagmanager.com/gtm.js?id=" +
                            i +
                            dl +
                            "&gtm_auth=" +
                            a +
                            "&gtm_preview=env-" +
                            e;
                    } else {
                        j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
                    }
                    f.parentNode.insertBefore(j, f);
                })(
                    window,
                    document,
                    "script",
                    "dataLayer",
                    "GTM-" + ConfigurationFac.getGTMContainerId(),
                    ConfigurationFac.getGTMEnvironmentId(),
                    ConfigurationFac.getGTMAuthenticationId()
                );

                /* eslint-disable */
                (function (i, s, o, g, r, a, m) {
                    i['GoogleAnalyticsObject'] = r;
                    i[r] = i[r] || function () {
                            (i[r].q = i[r].q || []).push(arguments)
                        }, i[r].l = 1 * new Date();
                    a = s.createElement(o),
                        m = s.getElementsByTagName(o)[0];
                    a.async = 1;
                    a.src = g;
                    m.parentNode.insertBefore(a, m)
                })(window, document, 'script', '//www.google-analytics.com/analytics.js', 'ga');
                /* eslint-enable */

                ga('create', ConfigurationFac.getGAContainerId(), 'auto');
            }

            function _scrollToTop() {
                var body = angular.element($document[0].getElementsByTagName("body"));
                if (body) {
                    $window.scrollTo(0, 0);
                    $window.scrollTo(0, 0);
                }
            }

            function _onDepositOpen() {
                $rootScope.$on('open', function (event, data) {
                    if (data === 'Deposit')
                        _goToDeposit();
                });
            }

            return {
                initBetSlip: _initBetSlip,
                fnGo: _fnGo,
                fnGetLocationPath: _fnGetLocationPath,
                onUser: _onUser,
                onLocationChangeStart: _onLocationChangeStart,
                onLocationChangeSuccess: _onLocationChangeSuccess,
                onRouteChangeStart: _onRouteChangeStart,
                onLogin: _onLogin,
                onLogout: _onLogout,
                onSessionExpired: _onSessionExpired,
                onAppReady: _onAppReady,
                onPageLoaded: _onPageLoaded,
                launchGTMEvent: _launchGTMEvent,
                createGTMandGA: _createGTMandGA,
                onDepositOpen: _onDepositOpen,
                onScrollToTop: _onScrollToTop
            };
        }

        return AppRootFac;
    });

